<div class=card>
    <app-quotation-requests class="p-4"></app-quotation-requests>
</div>